<!-- spinner component -->
<ngx-spinner [bdColor]="'rgba(0, 0, 0, 0.8)'" [size]="size" class="nv-spinner" type="ball-scale-multiple" [fullScreen]="fullScreen" [name]="name" [showSpinner]="_show === true">
    <div class="tm-loader__spinner"></div>
    @if (viewText) {
    <p>{{ loadingText }}</p>
    }
</ngx-spinner>
